"use client"

import { useMemo } from "react"
// Delegate to the single canonical browser client. Previously this module
// created its OWN createBrowserClient singleton, so any page that imported
// both this and "@/lib/supabase/client" ended up with TWO independent Supabase
// auth clients — each running its own token-refresh loop and competing for the
// same navigator LockManager lock. That doubled the lock contention behind the
// "stuck on the loading screen" freeze and let the two clients write auth
// cookies over each other. There must be exactly one browser auth client.
import { createClient as createCanonicalClient } from "@/lib/supabase/client"

export function createBrowserClient() {
  return createCanonicalClient()
}

export function createClient() {
  return createCanonicalClient()
}

// Hook version for React components.
export function useSupabase() {
  return useMemo(() => createCanonicalClient(), [])
}
